export default {
  state: {
    user: null,
    isManager: false,
    balance: null
  },

  mutations: {
    SET_USER(state, payload) {
      state.user = payload
    },
    SET_BALANCE(state, payload) {
      state.balance = payload
    }
  },

  actions: {
    // USER_INFO
    async updateUserInfo({ commit }, payload) {
      commit('SET_USER', payload)
    },
    async getBalance({ commit }, payload) {
      commit('SET_BALANCE', payload)
    }
  },

  getters: {
    user: state => state.user,
    isManager: state => state.user.is_manager,
    balance: state => state.balance
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js